import config from "../../config.json";
import { reportApiError, reportFailedBody } from "../errors/presentError";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const createObjectionAPI = async (token, formData) => {
    let responseData;
    try {
        await fetch(`${BASE_AUTH_API}objection`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        }).then((response) => response.json()).then((data) => responseData = data);
        if (responseData.success) {
            return responseData.newObjection
        }
        // the objection was not recorded (e.g. its e-mail could not be sent): one localized notice
        reportFailedBody(responseData)
        return
    } catch (error) {
        reportApiError(error)
        return
    }
}
export const getObjectionsIdsAPI = async (token, sId, branches) => {
    let responseData;
    try {
        const params = new URLSearchParams();
        sId.forEach(id => params.append('sId', id));
        const params2 = new URLSearchParams();
        branches.forEach(branch => params2.append('branches', branch));

        await fetch(`${BASE_AUTH_API}objection?${params.toString()}&${params2.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then((response) => response.json()).then((data) => responseData = data);
        if (responseData.success) {
            return responseData.orderIds
        }
        else {
            return
        }
    } catch (error) {
        reportApiError(error)
        return
    }
}
export const getObjectionsAPI = async (token, sId) => {
    let responseData;
    try {
        const params = new URLSearchParams();
        sId.forEach(id => params.append('sId', id));
        await fetch(`${BASE_AUTH_API}objection/all?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then((response) => response.json()).then((data) => responseData = data);
        if (responseData.success) {
            return responseData.objections
        }
        else {
            return
        }
    } catch (error) {
        reportApiError(error)
        return
    }
}